/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLogicBuffer = createReactComponent("logic-buffer", "IconLogicBuffer", [
  ["path", { d: "M22 12h-5", key: "svg-0" }],
  ["path", { d: "M2 9h5", key: "svg-1" }],
  ["path", { d: "M2 15h5", key: "svg-2" }],
  ["path", { d: "M7 5l10 7l-10 7z", key: "svg-3" }]
]);

export { IconLogicBuffer as default };
//# sourceMappingURL=IconLogicBuffer.js.map
